// src/pages/employer.jsx (o el nombre que le hayas dado)
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext"; // Asegúrate de ajustar la ruta si es necesario
import "./employer.css";

const Employer = () => {
  const { user } = useContext(AuthContext);

  // Si ya hay usuario, redirige a "mi-cuenta", de lo contrario, a la página de registro para empleadores.
  const targetLink = user ? "/mi-cuenta" : "/register?role=employer";

  return (
    <section className="employer-section">
      <div className="overlay">
        <div className="container text-center text-white employer-content">
          <h2 className="fw-bold">EMPLEADOR</h2>
          <p>Publica tus empleos fácilmente y conecta con talento latino</p>
          <Link
            to={targetLink}
            className="btn btn-danger"
            style={{ textDecoration: "none" }}
          >
            REGÍSTRATE Y PUBLICA TU EMPLEO
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Employer;